<template>
  <div class="expressManage column-me">
    <div class="card-div column-me">
      <div class="flex1 overflow-auto">
        <!--顺丰速运-->
        <div>
          <div class="title00">顺丰速运</div>
          <div class="row-me row-center margin-top20">
            <div class="left-title">是否开通：</div>
            <el-switch active-text="开通" v-model="sfObj.isOpen" @change="sfChange" :disabled="!canOperate"></el-switch>
          </div>
          <div class="row-me row-center margin-top20">
            <div class="left-title"><span class="red-star">*</span>月结号：</div>
            <div class="width350">
              <el-input placeholder="请输入月结号" style="width: 100%;" clearable v-model="sfObj.monthNo"
                        :disabled="!sfObj.isOpen || !canOperate"></el-input>
            </div>
            <div class="tips-text" @click="clickTips(1)">如何获取月结号？</div>
          </div>
          <div class="row-me row-center margin-top20">
            <div class="left-title"><span class="red-star">*</span>顾客编码：</div>
            <div class="width350">
              <el-input placeholder="请输入月结号" style="width: 100%;" clearable v-model="sfObj.customerCode"
                        :disabled="!sfObj.isOpen || !canOperate"></el-input>
            </div>
            <div class="tips-text" @click="clickTips(2)">如何获取顾客编码？</div>
          </div>
          <div class="row-me row-center margin-top20">
            <div class="left-title"><span class="red-star">*</span>沙箱校验码：</div>
            <div class="width350">
              <el-input placeholder="请输入沙箱校验码" style="width: 100%;" clearable v-model="sfObj.boxCode"
                        :disabled="!sfObj.isOpen || !canOperate"></el-input>
            </div>
          </div>
          <div class="row-me row-center margin-top20">
            <div class="left-title"><span class="red-star">*</span>生产校验码：</div>
            <div class="width350">
              <el-input placeholder="请输入生产校验码" style="width: 100%;" clearable
                        v-model="sfObj.productCode" :disabled="!sfObj.isOpen || !canOperate"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="row-me row-center flex-end1 padding-top20">
        <div class="btn-blue width100 btn-height40" @click="clickSave" v-if="canOperate">保存</div>
      </div>
    </div>

    <!-- 预览图片 -->
    <el-dialog :title="title" v-model="visible" :width="width" top="5vh" :destroy-on-close="true">
      <preview-images :images="previewImages"></preview-images>
    </el-dialog>

  </div>
</template>

<script>
import previewImages from "../../components/previewImages.vue";

export default {
  components: {
    previewImages
  },
  data() {
    return {
      sfObj: {
        isOpen: false,
        monthNo: '',
        customerCode: '',
        boxCode: '',
        productCode: '',
      },
      visible: false,
      title: '',
      width: '50%',
      previewImages: [],
      canOperate: false,
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.getData()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    sfChange(e) {
      if (!e) {
        this.sfObj.monthNo = ''
        this.sfObj.customerCode = ''
        this.sfObj.boxCode = ''
        this.sfObj.productCode = ''
      }
    },
    clickTips(index) {
      if (index === 1) {
        this.title = '获取月结号'
        this.width = '700px'
        this.previewImages = [
          {
            text: '方式一：请联系顺丰商务人员或者实体网店线下进行签约<br><br>' +
                '方式二：手机微信关注顺丰速运月结服务公众号——服务助手——我的月结，进行公众号在线申请<br><br>' +
                '方式三：登录丰桥服务网站，开发者信息页面点击立即申请显示申请二维码，扫码后线上自助进行签约',
            img: require('../../assets/img/月结号/图片9.png'),
          }
        ]
        this.visible = true
      } else if (index === 2) {
        this.title = '获取顾客编码'
        this.width = '1200px'
        this.previewImages = [
          {
            text: '请注册并登录顺丰开放平台(<a href="https://open.sf-express.com/" target="_blank" class="blue-text">https://open.sf-express.com/</a>),在业务中心-业务对接-开发者对接中找到创建的应用，在应用列表页查找到顾客编码，如下图所示',
            img: require('../../assets/img/顾客编码/图片10.png'),
          }
        ]
        this.visible = true
      }
    },
    //获取数据
    getData() {
      this.$getRequest('/admin/sfExpress/getExpress', {}).then((res) => {
        if (res) {
          this.sfObj.isOpen = res.data.isOpenExpress
          if (this.sfObj.isOpen) {
            this.sfObj.monthNo = res.data.monthCard
            this.sfObj.customerCode = res.data.clientCode
            this.sfObj.boxCode = res.data.checkWordDev
            this.sfObj.productCode = res.data.checkWord
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    clickSave() {
      if (this.sfObj.isOpen) {
        if (this.$method.isEmpty(this.sfObj.monthNo)) {
          this.$message.error('请输入月结号')
          return
        }
        if (this.$method.isEmpty(this.sfObj.customerCode)) {
          this.$message.error('请输入顾客编码')
          return
        }
        if (this.$method.isEmpty(this.sfObj.boxCode)) {
          this.$message.error('请输入沙箱校验码')
          return
        }
        if (this.$method.isEmpty(this.sfObj.productCode)) {
          this.$message.error('请输入生产校验码')
          return
        }
      }
      this.$postRequest('/admin/sfExpress/addExpress', {
        isOpenExpress: this.sfObj.isOpen,
        monthCard: this.sfObj.monthNo,
        clientCode: this.sfObj.customerCode,
        checkWordDev: this.sfObj.boxCode,
        checkWord: this.sfObj.productCode,
      }).then((res) => {
        if (res) {
          this.$message.success(res.message)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.expressManage {
  height: 100%;

  .card-div {
    height: 100%;
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    overflow: auto;
    padding: 20px;

    .title00 {
      font-size: 20px;
      font-weight: bold;
    }

    .left-title {
      width: 150px;
      text-align: right;
      margin-right: 10px;
    }

    .tips-text {
      font-size: 16px;
      color: #ff8f16;
      margin-left: 20px;
      cursor: pointer;
      user-select: none;

      &:hover {
        color: #ffaf54;
      }
    }
  }
}
</style>
